import { render, staticRenderFns } from "./I-0-1__IR-Page Title.vue?vue&type=template&id=2f4a877b&"
import script from "./I-0-1__IR-Page Title.vue?vue&type=script&lang=js&"
export * from "./I-0-1__IR-Page Title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports